import React, { memo, useContext } from "react";
import { ToolFnContext } from "./utils/context";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default memo(
  ({
    data,
    getText,
    btnRequestHandle,
    eventBus,
  }: {
    data: IMultiElementCombineMsg.ICapCardElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
    btnRequestHandle: ({
      url,
      btnId,
      retrieve_values,
      extra,
    }: IMultiElementCombineMsg.ISubmitParams) => void;
    eventBus?: any;
  }) => {
    const { quantity, content = [] } = data || {};
    const { track, btnExtraHandle } = useContext(ToolFnContext);

    const style = getDefaultComponentStyle(data) as any;

    const cardHandle = (
      item:
        | IMultiElementCombineMsg.ICapCardItem
        | IMultiElementCombineMsg.IBtnItem,
      event?: any
    ) => {
      event && event.stopPropagation && event.stopPropagation();

      const { id, extra, url, action_type, opentag_value, retrieve_values } =
        item || {};
      if (action_type === "request") {
        if (opentag_value && opentag_value.first_id) {
          // todo
          btnExtraHandle &&
            btnExtraHandle({
              action_type: "resetTag",
              opentag_value,
              callback: (code: number) => {
                code === 200 &&
                  btnRequestHandle({
                    url,
                    btnId: id,
                    retrieve_values,
                    extra,
                  });
              },
            });
        } else {
          btnRequestHandle({ url, btnId: id, retrieve_values, extra });
        }
      }
      if (action_type === "opentag") {
        btnExtraHandle && btnExtraHandle({ action_type, opentag_value });
      }
      if (action_type === "forward") {
        window.open(url);
      }

      track && track(id, "capCard");
    };

    const btnStyle = (button: IMultiElementCombineMsg.IBtnItem) => {
      const { text_color, border_color, background_color } = button;
      let style = {};
      text_color && Object.assign(style, { color: `#${text_color}` });
      border_color && Object.assign(style, { borderColor: `#${border_color}` });
      background_color &&
        Object.assign(style, { backgroundColor: `#${background_color}` });

      return style;
    };
    return (
      <div className={"sscard-capCardBox"} style={style}>
        {content.length > 0 &&
          content.map((item) => {
            const { icon, id, title, sub_title, disable, button } = item || {};

            return (
              <div
                className={`${"cardBox"} ${quantity === 2 ? "doubleRow" : ""} ${
                  disable ? "disabledCard" : ""
                }`}
                key={id}
                onClick={(e) => cardHandle(item, e)}
              >
                <div>
                  <div className={"header"}>
                    <img src={icon} />
                    <span className={"title"}>{getText(title.text)}</span>
                  </div>
                  {sub_title && (
                    <span className={"subTitle"}>
                      {getText(sub_title.text)}
                    </span>
                  )}
                </div>
                {button ? (
                  <span
                    onClick={(e) => cardHandle(button, e)}
                    className={"button"}
                    style={btnStyle(button)}
                  >
                    {getText(button.text)}
                  </span>
                ) : null}
              </div>
            );
          })}
      </div>
    );
  }
);
